import { Card, Flex, Typography } from 'antd';
import type { CSSProperties, ReactNode } from 'react';

const { Text } = Typography;

type Props = {
  title: string;
  value: ReactNode;
  icon: ReactNode;
  accentColor?: string;
};

export function SlaKpiCard({
  title,
  value,
  icon,
  accentColor = '#1e6df6',
}: Props) {
  const iconStyle = {
    '--sla-kpi-accent': accentColor,
  } as CSSProperties;

  return (
    <Card className="sla-kpi-card" styles={{ body: { padding: '1.25rem' } }}>
      <Flex align="center" gap={14}>
        <div className="sla-kpi-card__icon" style={iconStyle}>
          {icon}
        </div>
        <div>
          <Text type="secondary" className="ds-card-label">
            {title}
          </Text>
          <div className="ds-kpi-value sla-kpi-card__value">{value}</div>
        </div>
      </Flex>
    </Card>
  );
}
